<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">System Stats</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav>
					<a href="#" @click="onLoad()" v-if="article">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<div class="row">
			<div class="col-md-9">
				<div class="m-5 mt-0">
					<h2>System Stats</h2>
					Users: <b-form-input class="mb-2" v-model="customers.length"></b-form-input>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'Stats',
  data() {
	return{
		customers: null
	}
  },
  methods: {
	getStats: function(){
		this.$http.get(this.$config.ApiUri + "/Customers")
			.then((result) => {
				this.customers = result.data;
			}
		)
	},
	onLoad() {
		this.getStats();
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>